<div class="page-header-weekly">
  <button mat-button class="nav-button" (click)="navBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="title" style="padding-left: 100px;">

    YTD RESULTS BY STORE FOR WEEK no. {{ requestData.weekNo }} ENDING {{
    getWeekEndingDate(requestData.year, requestData.weekNo) }}

  </div>
  <div class="action-btn-container">
    <button mat-button color="accent" class="action-btn export-btn" (click)="exportClicked()"
      [disabled]="IsDownloading">
      <img class="download-icon"
        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
      Export
    </button>
  </div>
</div>
<div class="report-container">
  <div *ngIf="reportData && reportData.length > 0; else noData" class="table-container">
    <table mat-table [dataSource]="reportData" matSort>

      <!-- Group Header Columns -->
      <ng-container matColumnDef="shopGroup" sticky="">
        <th mat-header-cell *matHeaderCellDef colspan="1" class="grouped-header"></th>
      </ng-container>
      <ng-container matColumnDef="salesGroup">
        <th mat-header-cell *matHeaderCellDef colspan="4" class="grouped-header">Sales</th>
      </ng-container>

      <ng-container matColumnDef="ordersGroup">
        <th mat-header-cell *matHeaderCellDef colspan="6" class="grouped-header">Number of Orders</th>
      </ng-container>

      <ng-container matColumnDef="labourGroup">
        <th mat-header-cell *matHeaderCellDef colspan="3" class="grouped-header">Labour Cost %</th>
      </ng-container>

      <!-- Data Columns -->
      <ng-container matColumnDef="shop_name" sticky>
        <th mat-header-cell *matHeaderCellDef class="th-bordered">Store</th>
        <td mat-cell *matCellDef="let item">{{item.shop_name}}</td>
        <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
      </ng-container>

      <ng-container matColumnDef="this_year_this_week_sales">
        <th mat-header-cell *matHeaderCellDef class="heading">This Year</th>
        <td mat-cell *matCellDef="let item" class="amount">${{item.ytd_sales | number:'1.2-2'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">${{ salesSummary.total_ytd_sales | number:'1.2-2'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="last_year_this_week_sales">
        <th mat-header-cell *matHeaderCellDef class="heading">Last Year</th>
        <td mat-cell *matCellDef="let item" class="amount">${{item.last_year_ytd_sales | number:'1.2-2'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">${{ salesSummary.total_ly_sales | number:'1.2-2'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="sales_var">
        <th mat-header-cell *matHeaderCellDef class="heading">Var ($)</th>
        <td mat-cell *matCellDef="let item" class="amount">${{ (item.ytd_sales -
          item.last_year_ytd_sales) | number:'1.2-2' }}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">${{ salesSummary.sales_variance | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="sales_var_percent">
        <th mat-header-cell *matHeaderCellDef class="th-bordered heading">Var (%)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{ (item.last_year_ytd_sales === 0 ? 0 :
          ((item.ytd_sales - item.last_year_ytd_sales) / item.last_year_ytd_sales) * 100
          ) | number:'1.2-2' }}%
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">
          {{salesSummary.sales_growth | number:'1.2-2'}}%
        </td>
      </ng-container>

      <ng-container matColumnDef="this_week_cust_orders">
        <th mat-header-cell *matHeaderCellDef class="heading">This Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{item.ytd_no_of_cust_orders | number:'1.2-2'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">{{ salesSummary.total_cust_order_ty | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="last_year_cust_orders">
        <th mat-header-cell *matHeaderCellDef class="heading">Last Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{item.last_year_cus_order | number:'1.2-2'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">{{ salesSummary.total_cust_order_ly | number:'1.2-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="orders_var">
        <th mat-header-cell *matHeaderCellDef class="heading">Var ($)</th>
        <td mat-cell *matCellDef="let item" class="amount">{{(item.ytd_no_of_cust_orders - item.last_year_cus_order) | number:'1.2-2'}}
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">{{ salesSummary.cust_order_variance | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="orders_var_percent">
        <th mat-header-cell *matHeaderCellDef class="heading"> Var (%)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{ (item.last_year_cus_order === 0 ? 0 :
          ((item.ytd_no_of_cust_orders - item.last_year_cus_order) / item.last_year_cus_order) * 100
          ) | number:'1.2-2' }}%
        </td>
        <!-- <td mat-footer-cell *matFooterCellDef class="bold-footer">
            {{ (totals.orders_var / totals.last_year_cust_orders * 100) | number:'1.2-2' }}%
          </td> -->
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">
          {{salesSummary.cust_order_growth | number:'1.2-2'}}%
        </td>

      </ng-container>

      <ng-container matColumnDef="avg_sale_ty">
        <th mat-header-cell *matHeaderCellDef class="heading">Avg Sale (TY)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{ (item.ytd_no_of_cust_orders === 0 ? 0 : item.ytd_sales / item.ytd_no_of_cust_orders) |
          number:'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">{{ salesSummary.avg_sales_per_order_ty | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="avg_sale_ly">
        <th mat-header-cell *matHeaderCellDef class="th-class th-bordered heading">Avg Sale (LY)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{ (item.last_year_cus_order === 0 ? 0 : item.last_year_ytd_sales / item.last_year_cus_order) |
          number:'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">{{ salesSummary.avg_sales_per_order_ly | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="labour_percent_ty">
        <th mat-header-cell *matHeaderCellDef class="heading">This Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{ item.ytd_labour_per ?? 0 | number:'1.2-2' }}%</td>
        <!-- <td mat-footer-cell *matFooterCellDef class="bold-footer">{{ totals.labour_percent_ty | number:'1.2-2' }}%</td> -->
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">
          {{ salesSummary.total_labour_per_ty | number:'1.2-2'}}%
        </td>
      </ng-container>

      <ng-container matColumnDef="labour_percent_ly">
        <th mat-header-cell *matHeaderCellDef class="heading">Last Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{ item.last_year_labour_per ?? 0 | number:'1.2-2'
          }}%</td>
        <!-- <td mat-footer-cell *matFooterCellDef class="bold-footer">{{ totals.labour_percent_ly | number:'1.2-2' }}%</td> -->
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">
          {{ salesSummary.total_labour_per_ly | number:'1.2-2'}}%
        </td>
      </ng-container>

      <ng-container matColumnDef="labour_percent_var">
        <th mat-header-cell *matHeaderCellDef class="heading"> Var % </th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{ ((item.ytd_labour_per ?? 0) - (item.last_year_labour_per ?? 0)) | number:'1.2-2' }}%
        </td>
        <!--- <td mat-footer-cell *matFooterCellDef class="bold-footer">{{ totals.labour_percent_var | number:'1.2-2' }}%</td> -->
        <td mat-footer-cell *matFooterCellDef class="bold-footer amount">
          {{ salesSummary.labour_per_variance | number:'1.2-2'}}%
        </td>
      </ng-container>

      <!-- Table Structure -->
      <tr mat-header-row *matHeaderRowDef="groupHeaderColumns; sticky: true"></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="total-row"></tr>

    </table>
    <ng-template #noData>
      <div class="no-data-message">
        No data available for the selected criteria.
      </div>
    </ng-template>
  </div>
  <ng-template #noData>
    <div class="no-data-message"*ngIf="!isLoading">
      No Data Found.
  </div>
  <div *ngIf="isLoading" class="loading-message">
    Please wait, loading data...
  </div>
  </ng-template>

</div>